import Dashboard from '../layouts/Dashboard/Dashboard';

const indexRoutes = [
    { path: '/', name: 'Home', component: Dashboard },
];

export default indexRoutes;
